export default __webpack_public_path__ + "static/media/795.fa834c4a.png";